type RecipeMetadata = {
  slug: string;
  recipe_id: string;
  notificationID: string;
};

type OrderMetadata = {
  order_id: string;
  po_number: string;
  warehouse_id: string;
  order_meta_id: string;
  sub_po_number: string;
  notification_id: string;
  is_waiting_for_payment: string;
};

function isRecipeMetadata(
  metadata: Record<string, unknown>
): metadata is RecipeMetadata {
  return 'recipe_id' in metadata;
}

function isOrderMetadata(
  metadata: Record<string, unknown>
): metadata is OrderMetadata {
  return 'order_meta_id' in metadata;
}

export function parseNotificationRedirect(
  title: string,
  metadata: Record<string, unknown>
) {
  if (isRecipeMetadata(metadata)) {
    return `/recipes/${metadata.slug}`;
  }

  if (isOrderMetadata(metadata)) {
    let href = `/order-detail/${metadata.order_meta_id}?warehouse=${metadata.warehouse_id}`;
    if (title === 'Menunggu Pembayaran') href += '#submit-payment-proof';
    if (title === 'Diproses') href += '#rincian-produk';
    return href;
  }

  throw new Error('Unknown metadata');
}
